"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultInteractionGroups = void 0;
const hit_testable_group_1 = require("../../entities/groups/hit-testable-group");
const interaction_group_1 = require("../../entities/groups/interaction-group");
/**
 * @public
 * {@inheritDoc IDefaultInteractionGroups}
 */
class DefaultInteractionGroups {
    constructor(argProvider, plot) {
        this.hitTestable = new hit_testable_group_1.HitTestableGroup(argProvider, plot);
        this.draggable = new interaction_group_1.InteractionGroup(1 << 0, this.hitTestable, plot);
        this.clickable = new interaction_group_1.InteractionGroup(1 << 1, this.hitTestable, plot);
        this.hoverable = new interaction_group_1.InteractionGroup(1 << 2, this.hitTestable, plot);
    }
}
exports.DefaultInteractionGroups = DefaultInteractionGroups;
//# sourceMappingURL=default-interaction-groups.js.map